module.exports = __webpack_public_path__ + "static/media/icn_ui_favourites_inactive.6ac8751c.svg";